import * as types from './mutation-types'

export default {
    [types.LOAD_ORDERS_STATUS] (state, data) {
        state.status = data
    },
    [types.LOAD_ORDERS] (state, data) {
        state.orders = data?.data
    },

}

